module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "rel": "dns-prefetch",
      "src": this.url,
      "loading": "lazy",
      "title": "coworking bratislava 360",
      "height": "500",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44d2b8da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageFrame.vue
// module id = 131
// module chunks = 0 1 5 6 7 9 10 11